/** @format */

import { Observable, throwError } from 'rxjs';

import { Environment } from '@shared/data-access/interfaces';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';

export interface BNPLScriptData {
	['main.js']: {
		integrity: string;
		src: string;
	};
}

@Injectable({
	providedIn: 'root'
})
export class BNPLService {
	BNPL_URL: string;
	constructor(
		private http: HttpClient,
		private environment: Environment
	) {
		this.BNPL_URL = this.environment.thirdParty.bnpl.baseUrl;
	}

	/**
	 * @description Gets data assets needed for Buy Now Pay later script.
	 * @return asset object main.js: {src: '', integrity: ''}
	 */

	getBNPLAssets$(): Observable<BNPLScriptData> {
		return this.http.get<BNPLScriptData>(this.BNPL_URL).pipe(
			catchError((error) => throwError(error))
		);
	}
}
